import { cn } from '@/shadcn/lib/utils';
import { useSelected, useFocused, type RenderElementProps } from 'slate-react';

type Props = RenderElementProps;

export const MentionElement = ({ attributes, children, element }: Props) => {
  const selected = useSelected();
  const focused = useFocused();
  return (
    <span
      {...attributes}
      contentEditable={false}
      className={cn(
        'text-primary-deep bg-primary-deep/10 mx-px inline-block rounded-full px-1.5 py-1 align-baseline text-sm',
        selected && focused && 'outline-primary-deep outline'
      )}
    >
      {children}@{element.user.name}
    </span>
  );
};
